import Image from "next/image";
import { sbBlok } from "@/types/sb-types";
import { storyblokEditable } from "@storyblok/react";
import partnersSvg from "../../public/bg_graphics/partners.svg";
import clsx from "clsx";

const Partners = ({ blok }: sbBlok) => {
  const isDark = blok.dark_theme === true;

  return (
    <section
      {...storyblokEditable(blok)}
      className="relative [background-image:linear-gradient(180deg,rgba(9,9,9,0)_56.39%,#090909_98.24%)]"
    >
      {/* Background graphics */}
      <div
        className={`
          grid absolute top-0 left-0
          w-full h-full -z-[1] m-0
          overflow-hidden
        `}
      >
        <Image
          src={partnersSvg}
          alt="partners background arrows"
          fill
          sizes="100vw"
          className="object-cover object-top"
        />
      </div>
      <div
        className={`
          grid-container relative
          pt-12 pb-14 lg:pt-7 lg:pb-10
        `}
      >
        {/* Content */}
        <div
          className={`
            col-start-1 col-span-4
            lg:col-start-2 lg:col-span-14 2xl:col-start-4 2xl:col-span-26
            my-12 md:my-24
          `}
        >
          {blok?.title && (
            <h1 className="text-center mb-7 lg:mb-12">{blok.title}</h1>
          )}
          <div
            className={`
              flex flex-wrap justify-center
              gap-5 mx-auto max-w-[1200px]
            `}
          >
            {blok.images?.map((image: sbBlok, index: number) => (
              <div
                key={image._uid || index}
                className={clsx(
                  `
                  flex justify-center items-center
                  rounded-[10px] border border-tm-c-gray-700 bg-tm-c-gray-950
                  py-12 px-5 md:p-12
                  w-[30%] sm:w-[30%] md:w-[18%] lg:w-[17%]
                  max-w-[200px]
                  !aspect-square
                  overflow-hidden flex-shrink-0
                `,
                  { "bg-white": !isDark }
                )}
              >
                <div className="relative w-14 h-14 md:w-24 md:h-24">
                  <Image
                    className="object-contain"
                    src={image.image_details.filename}
                    alt={image.image_details.alt}
                    fill
                    sizes="(max-width: 768px) 56px, (max-width: 1280px) 96px, 128px"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
